import { baseApi } from '@/store/api/base.api';

export const courseApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCourses: builder.query<any, string>({
			query: (query) => ({
				url: `/courses?${query}`,
				method: 'GET',
			}),
		}),

		getCourseBySlug: builder.query<any, { slug: string; query: string }>({
			query: ({ slug, query }) => ({
				url: `/courses/${slug}?${query}`,
				method: 'GET',
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useGetCoursesQuery, useGetCourseBySlugQuery } = courseApi;
